module.exports = "<ng-container *ngIf=\"locations\">\n  <div class=\"d-flex flex-column\" *ngFor=\"let location of locationsKeys\">\n    <app-voucher-city-record class=\"d-block mb-3\"></app-voucher-city-record>\n  </div>\n</ng-container>\n\n<button type=\"button\" class=\"btn d-flex align-items-center justify-content-center w-100 py-3\" (click)=\"addLocation()\">\n  <i class=\"svg-container mr-2\" inlineSVG=\"/assets/images/action-icons/plus.svg\"></i>\n  Добавить город\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/voucher-city-input/voucher-city-input.component.html
// module id = ./src/app/shared/voucher-city-input/voucher-city-input.component.html
// module chunks = main